import { useState, useCallback } from 'react';

const useOnChangeHook = () => {
    const [input, setInput] = useState('');
    const onChangeTextCallback = useCallback((value) => {
        // Allow only numbers
        if (/^\d*$/.test(value)) {
            if (value < 1000) {
                setInput(value);
            }
        }
    }, []);
    return { input, onChangeTextCallback };
};

export default useOnChangeHook;
